// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1JxtK","legacyBtn":"MutateMid_legacyBtn__vj3zA"};